import { Injectable } from '@angular/core';
import { Http } from "@angular/http";
import {server,post_get_post_list} from "../index.path";
import { FilterModel } from '../../models/filterModel';
import { Post } from '../../models/post.model';
import { MarkerModel } from '../../models/marker.model';
import { SharedinfoService } from '../sharedinfo.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class FilterService {

  url_post_get_post_list = server + post_get_post_list;
  publications:Post[];
  markers:MarkerModel[];
  constructor(private http:Http,private _sharedInfoS:SharedinfoService) { 
    this.publications = [];
    this.markers = [];
  }

  private bothDates(filter:FilterModel):boolean{
    if(filter.date_start=="" && filter.date_final=="" || filter.date_start!="" && filter.date_final!="")
      return true;
    else {
      alert("Ambos campos e fecha deben de estar completos o vacios");
      return false;
    }
  }
  private allEmpty(filter:FilterModel):boolean{
    if(this.bothDates(filter))
      if(filter.event=="" && filter.date_start=="" && filter.date_final=="" && filter.time=="" && filter.username==""){
        return true;
      }
      return false;
  }
  private onlyUser(filter:FilterModel):boolean{
    if(this.bothDates(filter))
    if(filter.event=="" && filter.date_start=="" && filter.date_final=="" && filter.time=="" && filter.username!=""){
      return true;
    }
    return false
  }
  private onlyTime(filter:FilterModel):boolean{
    if(this.bothDates(filter))
    if(filter.event=="" && filter.date_start=="" && filter.date_final=="" && filter.time!="" && filter.username==""){
      return true;
    }
    return false
  }
  private onlyEvent(filter:FilterModel):boolean{
    if(this.bothDates(filter))
    if(filter.event!="" && filter.date_start=="" && filter.date_final=="" && filter.time=="" && filter.username==""){
      return true;
    }
    return false;
  }
  private eventAndDates(filter:FilterModel):boolean{
    if(this.bothDates(filter)){
      if(filter.event!="" && filter.date_start!="" && filter.date_final!="" && filter.time=="" && filter.username==""){
        return true;
      }
      return false;
    }
  }
  private eventDatesAndTime(filter:FilterModel):boolean{
    if(this.bothDates(filter))
      if(filter.event!="" && filter.date_start!="" && filter.date_final!="" && filter.time!="" && filter.username==""){
        return true;
      }
      return false;
  }
  private allFill(filter:FilterModel):boolean{
    if(this.bothDates(filter))
    if(filter.event!="" && filter.date_start!="" && filter.date_final!="" && filter.time!="" && filter.username!=""){
      return true;
    }
    return false;
  }
  private eventTimeAndUser(filter:FilterModel):boolean{
    if (this.bothDates(filter))
      if(filter.event!="" && filter.date_start=="" && filter.date_final=="" && filter.time!="" && filter.username!=""){
        return true;
      }
      return false;
  }
  private eventAndUser(filter:FilterModel):boolean{
    if (this.bothDates(filter))
      if(filter.event!="" && filter.date_start=="" && filter.date_final=="" && filter.time=="" && filter.username!=""){
        return true;
      }
      return false;
  }
  private onlyDates(filter:FilterModel):boolean{
    if(filter.event=="" && filter.date_start!="" && filter.date_final!="" && filter.time=="" && filter.username==""){
        return true;
      }
      return false;
  }
  private datesAndTime(filter:FilterModel):boolean{
    if(filter.event=="" && filter.date_start!="" && filter.date_final!="" && filter.time!="" && filter.username==""){
        return true;
      }
      return false;
  }
  private datesTimeAndUser(filter:FilterModel):boolean{
    if(filter.event=="" && filter.date_start!="" && filter.date_final!="" && filter.time!="" && filter.username!=""){
        return true;
      }
      return false;
  }
  private timeAndUser(filter:FilterModel):boolean{
    if(this.bothDates)
      if(filter.event=="" && filter.date_start=="" && filter.date_final=="" && filter.time!="" && filter.username!=""){
        return true;
      }
      return false;
  }
  private eventAndTime(filter:FilterModel):boolean{
    if (this.bothDates)
      if(filter.event!="" && filter.date_start=="" && filter.date_final=="" && filter.time!="" && filter.username==""){
        return true;
      }
      return false;
  }
  private datesAndUser(filter:FilterModel):boolean{
    if(filter.event=="" && filter.date_start!="" && filter.date_final!="" && filter.time=="" && filter.username!=""){
        return true;
      }
      return false;
  }
  private eventDatesAndUser(filter:FilterModel):boolean{
    if(filter.event!="" && filter.date_start!="" && filter.date_final!="" && filter.time=="" && filter.username!=""){
        return true;
      }
      return false;
  }

  filtering2(filter:FilterModel,lat:string,lng:string){    
    let url_final:string  = this.url_post_get_post_list;
    console.log('filtering2 url_final '+url_final);

    url_final= url_final+'latitude='+lat;
    console.log('filtering2 url_final '+url_final);
    url_final= url_final+'&longitude='+lng;
    console.log('filtering2 url_final '+url_final);
    url_final = url_final+'&radius='+filter.km;
    console.log('filtering2 url_final '+url_final);
    if(filter.event!='') url_final = url_final+"&title="+filter.event;
    if(filter.username!='') url_final = url_final+"&username="+filter.username;
    if(filter.date_final!=''){
      url_final = url_final+"&start_date="+filter.date_start;
      if(filter.time!='') url_final = url_final+' '+filter.time;
    }
    if(filter.date_final!=''){
      url_final = url_final+"&end_date="+filter.date_final;
      if(filter.time_end!='') url_final = url_final+' '+filter.time_end;
    }
    return this.makeRequest(url_final);
    
  }

  filtering(filter:FilterModel){
    let url_final:string;

    if(this.allEmpty(filter)){
      alert("Intenta con algun campo");
      return Observable.of();
    }
    else if(this.onlyUser(filter)){
      url_final = this.url_post_get_post_list+"&username="+filter.username;
      return this.makeRequest(url_final);
    }
    else if (this.onlyTime(filter)) {
      url_final = this.url_post_get_post_list+"&time_event="+filter.time;
      return this.makeRequest(url_final);
    }
    else if (this.onlyEvent(filter)) {
      url_final = this.url_post_get_post_list+"&title="+filter.event;
      return this.makeRequest(url_final);
    }
    else if(this.eventAndDates(filter)){
      url_final = this.url_post_get_post_list+"&title="+filter.event+"&start_date="+filter.date_start+"&end_date="+filter.date_final;
      return this.makeRequest(url_final);
    }
    else if (this.eventDatesAndTime(filter)) {
      url_final = this.url_post_get_post_list+"&title="+filter.event+"&start_date="+filter.date_start+"&end_date="+filter.date_final+"&time_event="+filter.time;
      return this.makeRequest(url_final);
    }
    else if (this.allFill(filter)) {
      url_final = this.url_post_get_post_list+"&title="+filter.event+"&start_date="+filter.date_start+"&end_date="+filter.date_final+"&time_event="+filter.time+"&username="+filter.username;
      return this.makeRequest(url_final);
    }
    else if (this.eventTimeAndUser(filter)) {
      url_final = this.url_post_get_post_list+"&title="+filter.event+"&time_event="+filter.time+"&username="+filter.username;
      return this.makeRequest(url_final);
    }
    else if(this.eventAndUser(filter)){
      url_final = this.url_post_get_post_list+"&title="+filter.event+"&username="+filter.username;
      return this.makeRequest(url_final);
    }
    else if (this.onlyDates(filter)) {
      url_final = this.url_post_get_post_list+"start_date="+filter.date_start+"&end_date="+filter.date_final;
      return this.makeRequest(url_final);
    }
    else if (this.datesAndTime(filter)) {
      url_final = this.url_post_get_post_list+"&start_date="+filter.date_start+"&end_date="+filter.date_final+"&time_event="+filter.time;
      return this.makeRequest(url_final);
    }
    else if (this.datesTimeAndUser(filter)) {
      url_final = this.url_post_get_post_list+"start_date="+filter.date_start+"&end_date="+filter.date_final+"&time_event="+filter.time+"&username="+filter.username;
      return this.makeRequest(url_final);
    }
    else if (this.timeAndUser(filter)) {
      url_final = this.url_post_get_post_list+"&time_event="+filter.time+"&username="+filter.username;
      return this.makeRequest(url_final);
    }
    else if (this.eventAndTime(filter)) {
      url_final = this.url_post_get_post_list+"&title="+filter.event+"&time_event="+filter.time;
      return this.makeRequest(url_final);
    }
    else if (this.datesAndUser(filter)) {
      url_final = this.url_post_get_post_list+"start_date="+filter.date_start+"&end_date="+filter.date_final+"&username="+filter.username;
      return this.makeRequest(url_final);
    }
    else if(this.eventDatesAndUser(filter)){
      url_final = this.url_post_get_post_list+"&title="+filter.event+"&start_date="+filter.date_start+"&end_date="+filter.date_final+"&username="+filter.username;
      return this.makeRequest(url_final);
    }
    else{
      return Observable.of();
    }
  }

  makeRequest(url_final:string){
    console.log("make request: "+url_final);
    return this.http.get(url_final)
     .map((res: any) => {
       console.log(res.json());
       return res.json();
     }).catch((err: Response) => {
       let error = err.json();
       alert("algo salio mal: "+JSON.stringify(error) + " intentalo de nuevo");
       return Observable.throw(error)
     })
  }



}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/nservices/map/filter.service.ts